module.exports = __webpack_public_path__ + "static/img/icon_head.903946e2.png";